import { useTypedSelector } from '@Features/store';
import api from '@Services/api';

/**
 * Action gating for the shared standalone/bundle pages.
 *
 * `can` mirrors the backend adminCan codes for OPERATING actions (rosters,
 * ban/unban, the active toggle, grading) — in the instructor portal these are
 * always allowed here; assistant grants are enforced server-side.
 *
 * `canAuthor` is for AUTHORING actions (create/edit/archive courses, lectures
 * and bundles, featured curation, curriculum and unit editing): standalone
 * content is admin-authored, so the instructor portal is view-only and
 * canAuthor is always false there. The backend 403s these routes for
 * instructors regardless — this only keeps the controls out of the UI.
 */
const useAdminActionPermissions = () => {
	const auth = useTypedSelector((state) => state.auth);
	const isAdmin = api.defaults.baseURL?.includes('/admin/') === true;
	const permissions = (auth as any).permissions;
	const can = (code: string) =>
		!isAdmin || auth.user.type === 'super' || Boolean(permissions?.has(code));
	const canAuthor = (code: string) => isAdmin && can(code);
	return { can, canAuthor, isAdminPortal: isAdmin };
};

export default useAdminActionPermissions;
